// Swiper is imported already
class productDetailSwiper extends HTMLElement {
  constructor() {
    super();

    this.swiperElement = this.querySelector('[data-product-detail-swiper]');

    this.swiperOptions = {
      direction: 'horizontal'
    }

    this.init();
  }

  init() {
    window.addEventListener('load', (event) => {
      this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
    });
    Fancybox.bind("[data-fancybox]", {
      animated: false,
      showClass: false,
      infinite: false
    });
  }
}

if(!customElements.get('product-detail-swiper')) {
  customElements.define('product-detail-swiper', productDetailSwiper);
}

class productInfo extends HTMLElement {

  constructor() {
    super();
    this.productForm = this.querySelector('product-form');
    this.productFormQuantity = this.productForm?.querySelector('input[name="quantity"]');
    this.quantityInput = this.querySelector('quantity-input');
    this.quantityInputElement = this.quantityInput?.querySelector('input[name="quantity"]');
    this.quantityInputElement?.addEventListener('change', () => {
      this.handleQuantityInput();
    })
    this.moveReviewElement();
  }

  /**
   * handleQuantityInput
   * @description Set the quantity from the quantity input web component to the product form web component.
   */
  handleQuantityInput() {
    this.productFormQuantity.value = this.quantityInputElement.value;
  }

  /**
   * moveReviewElement
   * @description Check if the element with the specified ID exists and move it after the element with the specified class.
   */
  moveReviewElement() {
    const extensionElement = this.querySelector(
      "#etrusted-product-review-list-widget-product-star-extension"
    );
    const titleElement = document.querySelector(".product__title");

    if (extensionElement && titleElement) {
      titleElement.after(extensionElement);
    }
  }
}

if(!customElements.get('product-info')) {
  customElements.define('product-info', productInfo);
}

// Swiper is imported already
class productBlockReviews extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {

    this.URLparams = new URLSearchParams(location.search.slice(1));
    if (this.URLparams.has('judgeme_review_source')) {
      this.querySelector('read-more').classList.toggle('read-more--expanded');
    }

  }
}

if(!customElements.get('product-block-reviews')) {
  customElements.define('product-block-reviews', productBlockReviews);
}
